import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { Tooltip, Typography } from '@material-tailwind/react';
import { formatCamelCaseToText } from '../lib/formatters';
import { formatMoney } from '../lib/money';

interface InvoiceReceiptProps {
	tipFee?: number;
	relayFee?: number;
	producerLocationPay?: number;
	cash?: number;
	refund?: number;
	net?: number;
	recurringCharges?: number;
}

const InvoiceReceipt = (props: InvoiceReceiptProps) => {
	const { net } = props;

	const invoiceLineToRelabel = {
		producerLocationPay: 'Additional Charges',
	};

	const invoiceLineOrder = {
		relayFee: 1,
		tipFee: 2,
		cash: 3,
		refund: 4,
		recurringCharges: 5,
		producerLocationPay: 6,
		net: 7,
	};

	const receiptLines: any = [];
	Object.keys(props)
		.sort((a, b) => invoiceLineOrder[a] - invoiceLineOrder[b])
		.forEach((key) => {
			if (key !== 'net' && props[key] !== 0) {
				receiptLines.push({
					label: invoiceLineToRelabel[key] || formatCamelCaseToText(key),
					amount: props[key],
                    key,
				});
			}
		});

	return (
		<div className="flex flex-col">
			{receiptLines.map(({ label, amount, key }, index) => (
				<ReceiptLine label={label} amount={amount} lineItem={key} finalLine={index === receiptLines.length - 1} />
			))}
			<ReceiptLine label="Net" amount={net} lineItem={"net"} className={'py-1 border-black flex flex-row justify-between'} />
		</div>
	);
};

const ReceiptLine = ({ label, amount, finalLine = false, className = '', lineItem}) => {

    const invoiceLineInformation = {
		relayFee: 'Fee charged by Relay for the delivery service',
		tipFee: 'Tips collected by restaurant and owed to Relay courier',
		cash: 'Orders directly paid for in cash by the customer to the courier and thus owed back to Relay',
		refund: 'Refunded orders',
		recurringCharges: 'See invoice for details',
		producerLocationPay: 'See invoice for details',
		net: 'Total amount charged',
	};

	return (
		<div
			className={
				className ||
				`${
					finalLine ? 'border-b-2 border-solid' : 'border-b-2 border-dashed'
				} py-1 border-black flex flex-row justify-between`
			}
		>
            <div className='flex flex-row justify-left gap-2 align-middle'>
                <Tooltip
                    content={<div className="italic flex">{invoiceLineInformation[lineItem]}</div>}
                    placement="left"
                >
                    <InformationCircleIcon className="h-4 w-4 text-blue-gray self-center" />
                </Tooltip>
                <Typography variant="small" color="blue-gray" className="italic">
                    {label}
                </Typography>
            </div>
			<Typography variant="small" color={amount < 0 ? 'red' : 'blue-gray'} className="font-semibold">
				{amount < 0 ? `(${formatMoney(-1 * amount)})` : `${formatMoney(amount)}`}
			</Typography>
		</div>
	);
};

export default InvoiceReceipt;
